import { FIELDS } from '../partials/Checkout/Form/constants';

export const getCookie = (name) => {
  try {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
  } catch (error) {
    // do nothing
  }
  return null;
};

const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const setPartnerCookie = () => {
  try {
    if (typeof window !== 'undefined') {
      const query = new URLSearchParams(window.location.search);
      const affiliate_id = query.get('ref') || '';
      if (affiliate_id) {
        setCookie(FIELDS.AFFILIATE_ID, affiliate_id, 30);
        fetch(`/partner/${affiliate_id}`)
          .then((res) => res.text())
          .then((partner_id) => {
            if (partner_id) {
              setCookie(FIELDS.PARTNER_ID, partner_id, 30);
            }
          });
      }
    }
  } catch (error) {
    // do nothing
  }
};
